import React from "react";

export const ProgressRing = ({ value = 0, size = 64, stroke = 6, label = true }) => {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c - (value / 100) * c;
  return (
    <div className="relative inline-grid place-items-center" style={{ width: size, height: size }} data-testid="progress-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(var(--muted))" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(var(--accent))" strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="butt"
          style={{ transition: "stroke-dashoffset 600ms ease" }} />
      </svg>
      {label && (
        <span className="absolute text-sm font-bold tabular-nums">{value}%</span>
      )}
    </div>
  );
};

export default ProgressRing;
